import * as actionsTypes from "./actionTypes";
const initialState = {
  user: {},
  userDetails: {},
  passCode: "",
  passCorrect: false,
  showPass: true,
  page: "pin",
};
export default function userData(state = initialState, action) {
  switch (action.type) {
    case actionsTypes.STORE_USER:
      return { ...state, user: action.user };
    case actionsTypes.STORE_USER_DETAILS:
      return { ...state, userDetails: action.userDetails };
    case actionsTypes.SET_ATTRIBUTE:
      return { ...state, [action.payload.name]: action.payload.value };
    default:
      return state;
  }
}
